module.exports = __webpack_public_path__ + "static/media/iconEmail.34c52102.gif";